// Use window.$ directly to avoid timing issues with jQuery loading
var $ = window.$ || window.jQuery;

function show_spinner(container) {
  $(container).append('<div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1000; background-color: rgba(255, 255, 255, 0.8); display: flex; align-items: center; justify-content: center;"><img style="width: 64px; height: 64px;" src="/assets/loading-buffering.gif"></div>');
}

// Expose globally for use in other modules
window.show_spinner = show_spinner;
